import { render, staticRenderFns } from "./TianjiaPlanTwo.vue?vue&type=template&id=3f0f4efb&scoped=true&"
import script from "./TianjiaPlanTwo.vue?vue&type=script&lang=js&"
export * from "./TianjiaPlanTwo.vue?vue&type=script&lang=js&"
import style0 from "./TianjiaPlanTwo.vue?vue&type=style&index=0&id=3f0f4efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f4efb",
  null
  
)

export default component.exports